import { cart } from "@core/gql-mockups/cart";
import { minimize_str } from "@core/helpers/string";

export const ADD_TO_CART = minimize_str(`
    mutation ($product_id: ID, $mix_variant: [String], $count: Int, $lang: String, $bundle_id: ID, $price_key: String) {
   result: addToCart(product_id: $product_id,bundle_id: $bundle_id, mix_variant: $mix_variant, count: $count, is_inquiry: 0, lang: $lang, price_key: $price_key) ${cart}
  }
  `);

export const SYNC_LOCAL_CART = minimize_str(`
    mutation ($input: localCartInput) {
   result: syncLocalCart(input: $input) {
    id
   }
  }
  `);

export const REMOVE_FROM_CART = minimize_str(`
    mutation ($product_id: ID, $mix_variant: [String], $lang: String, $bundle_id: ID, $price_key: String) {
   result: removeFromCart(product_id: $product_id,bundle_id: $bundle_id, mix_variant: $mix_variant, is_inquiry: 0, lang: $lang, price_key: $price_key) ${cart}
  }
`);
export const REMOVE_ALL_FROM_CART = minimize_str(`
    mutation ($lang: String, $products: [removeAllFromCartProductInput]) {
   result: removeAllItemsFromCart(lang: $lang, is_inquiry: 0, products: $products) ${cart}
  }
`);

export const ADD_TO_NOTIFICATIONS = minimize_str(`
mutation ($product_id: ID, $mix_variant: [String], $is_notify: Boolean) {
 result: addToNotifies(product_id: $product_id, mix_variant: $mix_variant, is_notify: $is_notify) {
    success
    message
  }
}
`);

export const ADD_TO_FAVORITE = minimize_str(`
  mutation($product_id: ID, $mix_variant: [String], $is_favorite: Boolean) {
  result:  addToFavorites(product_id: $product_id, mix_variant: $mix_variant, is_favorite: $is_favorite) {
      success
      message
    }
  }
`);